import { ExclamationCircleOutlined, LinkOutlined, MailOutlined, PhoneOutlined, RocketOutlined } from '@ant-design/icons';
import { Alert, Button, Form, Grid, Input, notification, Spin } from 'antd';
import { useEffect, useState } from 'react';
import useAuth from 'redux/auth/auth.hook';
import history from 'redux/history';
import { PATHS } from 'res/routes';
import classes from './style.module.scss';

const { useBreakpoint } = Grid;

const SignForm = () => {
  const { signRequestSaga, auth } = useAuth();
  const { md } = useBreakpoint();
  const [loading, setLoading] = useState(false);
  const [showPaymentError, setShowPaymentError] = useState(false);

  console.log('auth ==>', auth);

  const onFinish = (values: any) => {
    console.log('onFinish ====>', values);
    setLoading(true);
    signRequestSaga(values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {
    if (auth.profile) {
      setLoading(false);
      setShowPaymentError(false);
      if (auth.profile.visited_at == '2019-07-26 22:42:53') {
        history.push(PATHS.CAMERA);
      } else if (auth.profile.account_type == 'Shared') {
        history.push(PATHS.SHARED_CAMERA);
      } else {
        history.push(PATHS.HOME);
      }
    }
  }, [auth.profile]);

  useEffect(() => {
    if (auth.message) {
      if (auth.message != '') {
        setLoading(false);
        // Check if this is the payment error message
        if (auth.message.includes('Payment issue detected on your account')) {
          setShowPaymentError(true);
        } else {
          setShowPaymentError(false);
          notification.open({
            message: auth.message,
          });
        }
      }
    }
  }, [auth.message]);

  const handleTryNewVersion = () => {
    window.open('https://v2.huntcontrol.com', '_blank', 'noopener,noreferrer');
  };

  return (
    <Spin spinning={loading} size="large">
      {showPaymentError && (
        <div style={{ width: md ? 500 : 300, marginBottom: 32 }}>
          <Alert
            message="Payment Issue on Your Account"
            description={(
              <div className={classes.paymentErrorContent}>
                <p>There&apos;s been an issue with the payment on your account. Please contact us using one of these methods:</p>
                <div className={classes.contactMethods}>
                  <div className={classes.contactMethod}>
                    <LinkOutlined className={classes.contactIcon} />
                    <div>
                      <strong>Online Account:</strong>
                      <a href="https://wiseeyetech.com/my-account" target="_blank" rel="noopener noreferrer">
                        wiseeyetech.com/my-account
                      </a>
                    </div>
                  </div>
                  <div className={classes.contactMethod}>
                    <PhoneOutlined className={classes.contactIcon} />
                    <div>
                      <strong>Call Customer Service:</strong>
                      <p>225-478-4026 (Mon-Fri, 9 AM - 5 PM CST)</p>
                    </div>
                  </div>
                  <div className={classes.contactMethod}>
                    <LinkOutlined className={classes.contactIcon} />
                    <div>
                      <strong>Live Chat:</strong>
                      <a href="https://wiseeyetech.com" target="_blank" rel="noopener noreferrer">
                        wiseeyetech.com
                      </a>
                    </div>
                  </div>
                  <div className={classes.contactMethod}>
                    <MailOutlined className={classes.contactIcon} />
                    <div>
                      <strong>Email:</strong>
                      <a href="mailto:support@wiseeyetech.com">support@wiseeyetech.com</a>
                    </div>
                  </div>
                </div>
              </div>
            )}
            type="error"
            showIcon
            icon={<ExclamationCircleOutlined />}
            closable
            onClose={() => setShowPaymentError(false)}
          />
        </div>
      )}
      <div style={{ width: md ? 500 : 300, marginBottom: 32 }}>
        <div className={classes.newVersionBanner}>
          <div className={classes.bannerLeftBorder} />
          <div className={classes.bannerContent}>
            <div className={classes.bannerHeader}>
              <div className={classes.bannerIconWrapper}>
                <RocketOutlined className={classes.bannerIcon} />
              </div>
              <span className={classes.bannerBadge}>NEW</span>
            </div>
            <div className={classes.bannerText}>
              <h3 className={classes.bannerTitle}>New HuntControl Experience</h3>
              <p className={classes.bannerDescription}>
                A new version of HuntControl is available. Would you like to check it out?
              </p>
            </div>
            <Button
              type="primary"
              icon={<RocketOutlined />}
              onClick={handleTryNewVersion}
              className={classes.bannerButton}
            >
              Try Now
            </Button>
          </div>
        </div>
      </div>
      <Form initialValues={{ remember: true }} onFinish={onFinish} onFinishFailed={onFinishFailed}>
        <div className={classes.formWrapper} style={{ width: md ? 500 : 300 }}>
          <h4>Sign in to your account</h4>

          <div className={classes.formItemLabel}>Email/Username</div>
          <Form.Item name="username" rules={[{ required: true, message: 'Please input your email!' }]}>
            <Input size="large" />
          </Form.Item>

          <div className={classes.formItemLabel}>Password</div>
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password size="large" />
          </Form.Item>

          <Form.Item>
            <Button className={classes.btnSignin} htmlType="submit" size="large">
              Sign In
            </Button>
          </Form.Item>
          <div>
            <a href="/authResetPassword">Forgot your password?</a>
          </div>
          <div style={{ marginTop: '10px' }}>
            <a href="https://wiseeyetech.com/product/huntcontrol-subscription/">Need to purchase a subscription?</a>
          </div>
        </div>
      </Form>
    </Spin>
  );
};

export default SignForm;
